import React from 'react';
import { NotificationProps } from '../types';
import { MessageIcon } from './MessageIcon';
import './Notification.scss';

export const Notification = ({
  type,
  message,
}: NotificationProps): JSX.Element => (
  <div className="notification-wrapper">
    <MessageIcon type={type} />
    <span className="text">{message}</span>
  </div>
);
